/// <amd-module name="typeahead/core/presentation/IInputElementFocusHandler" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../../typings/thirdparty/jquery/jquery.d.ts" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />

export interface IInputElementFocusHandler<T> {
    handleInputElementFocus($inputElement: JQuery, context: IContext): JQueryPromise<T>;
}

export const isInputElementFocusHandler: IPluginIdentifier = (plugin: Object): boolean => {
    return (typeof plugin === "object") &&
        (typeof ((plugin as IInputElementFocusHandler<any>).handleInputElementFocus) === "function");
};
